import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import template from './failure.html';

@Component({
  controllerAs: 'paymentFailure',
  template
})

export default class PaymentFailure {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$stateParams',
    '$cookies',
    '$state',
    '$window',
    'authService',
    'orderService',
    'APP',
    'spinnerService',
    '$sce'
  ];

  constructor($scope, $ngRedux, $stateParams, $cookies,$state,
  $window,
  $auth,$order,
  APP,spinner,$sce) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
        
    this.$stateParams = $stateParams;
    this.$ngRedux = $ngRedux;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.reasonCodeCheck=$stateParams.reasonCode;
    var logString=$stateParams.logString;
    var orderId= $stateParams.orderId;
    const reasonCode = $stateParams.reasonCode;
    this.$window = $window;
    this.$auth = $auth;
    this.$order = $order;
    this.$state = $state;
    this.$sce = $sce;
    this.APP = APP;
    this.spinner = spinner;
    let text = '';

    var data = {
      message : logString
    };
    this.$order.printPaymentLogs(orderId,data).then(success => 
      {
        console.log("Successfully Printed");
      })
    .catch(err => {
        console.log("Failed to print logs");
    });

    this.isguestLogin = $auth.isGuestLogin();

    /*eslint-disable*/
    switch (reasonCode) {
        case '101':
          text = 'Your card has been declined. Please try again using different card';
            break;
        case '0':
          text = 'Entered CVV number is incorrect. Your payment reversal has been processed.';
          break;
        case '100':
          text = 'Error in Authentication.';
          break;
        default:
          text = this.getErrorMessage(reasonCode);
      }
    this.errorMessage = text;
    /*eslint-enable*/

    try {
          sessionStorage.removeItem('discountCoupon');
          sessionStorage.removeItem('birdbuckCoupon');
          sessionStorage.removeItem('erplyBBDiscount');
          sessionStorage.removeItem('erplyBBCouponCodes');
          sessionStorage.removeItem('erplyPromotionCodes');
          sessionStorage.removeItem('erplyPromotionDiscount');
          sessionStorage.removeItem('orderNotesSession');      
          sessionStorage.removeItem('guestoauth');
          sessionStorage.removeItem('isGuestUserLoggedIn');
        }
        catch (e) {
          $cookies.remove('discountCoupon');
          $cookies.remove('birdbuckCoupon');
          $cookies.remove('erplyBBDiscount');
          $cookies.remove('erplyBBCouponCodes');
          $cookies.remove('erplyPromotionCodes');
          $cookies.remove('erplyPromotionDiscount');
          $cookies.remove('orderNotesSession');
      }

    $scope.$on('$destroy', disconnect);
  }

  goToHomePage() {
    let storeName = '';
    console.log("Failure detail",this.detail);
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.detail.store && this.detail.store.storeName) {
        storeName = this.detail.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  trustSrc(src) {
    return this.$sce.trustAsResourceUrl(src);
  }

  getErrorMessage(reasonCode){
    let h_text = "";
    switch (reasonCode) {
      case '04':
      case 'AVS_N':
      // h_text = 'Your billing address does not match the address on file with your credit card company. Click <a href="#" style="color: #0000EE;" ng-click="goToProfile()">here</a> to update the billing address in your profile, then try again.';
      h_text = 'Your billing address does not match the address on file with your credit card company. Click <a style="color: #0000EE;cursor: pointer;" href="/dashboard/profile/user/edit"> here</a> to update the billing address in your profile, then try again.';
      break;
      case '14':
      h_text = 'The entered card number is incorrect.  Please check the number and try again.';
      break;
      case '54':
      h_text = 'Your card has expired.  Please try again using a different card.';
      break;
      case '51':
      h_text = 'Your card has been declined. Please try again using different card';
	    break;
      case 'N7':
      case 'CVV_N':
      h_text = 'The entered CVV number is incorrect.  Please check the number and try again.';
      break;
      // case 'EC':
      // h_text = 'CID FORMAT ERROR';
      // break;
      default:
      h_text = 'We are unable to process your transaction at this time.';
    }
    return h_text;
  }

  goToProfile(){
    this.spinner.show('appSpinner');
    this.$state.go('profile.edit');
  }

  mapState(state) {
    return {
      detail: state.auth.profile ? state.auth.profile : state.auth.guestprofile
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/order/payment/failure.js